const DEFAULT_ORIGIN = "https://rghtnow.com";

export const getAppBasePath = () =>
  new URL(process.env.PUBLIC_URL || "/", DEFAULT_ORIGIN).pathname.replace(/\/+$/, "");

export const getAppPath = (path = "") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${getAppBasePath()}${normalizedPath}`;
};

export const getAppUrl = (path = "") => {
  const origin = typeof window === "undefined" ? DEFAULT_ORIGIN : window.location.origin;
  return `${origin}${getAppPath(path)}`;
};
